import React from "react";
import { Icon, Button } from "./styled";

function FiltersButton({ className, activeFilters, results, onClick, ...props }) {
  const handleOnClick = () => {
    onClick();
  };

  const getFilterCount = () => {
    let total = 0;
    Object.keys(activeFilters).forEach((x) => {
      total += activeFilters[x].length;
    });
    return total;
  };

  const filterCount = getFilterCount();

  return (
    <Button
      className={className}
      type="dark"
      {...props}
      onClick={handleOnClick}
    >
      {filterCount === 0 ? (
        <Icon src="/filter-unselected.svg" alt="" />
      ) : (
        <Icon src="/filter-selected.svg" alt="" />
      )}
      {results?.length > 0
        ? `${results.length} Result${results.length > 1 ? "s" : ""}`
        : `0 Results`}
    </Button>
  );
}

export default FiltersButton;
